import { firestore } from 'firebase/app';
import { ProductCategoryCollection } from './ProductCategoryCollection';
import { ProductCategory } from './ProductCategory';

export class ProductCategoryService {
  private collection: ProductCategoryCollection;

  private productCategories: Record<string, ProductCategory> = {};

  private byParentId = new Map<string, Promise<ProductCategory[]>>();
  private byNameAndLineage = new Map<string, Promise<ProductCategory | null>>();

  constructor(db: firestore.Firestore) {
    this.collection = new ProductCategoryCollection(db);
  }

  public listProductCategoriesByParentId(id: string): Promise<ProductCategory[]> {
    if (!this.byParentId.has(id)) {
      this.byParentId.set(
        id,
        this.collection
          .listProductCategoriesByParentId(id)
          .then((categories) =>
            categories.map((category) => this.getOrCacheProductCategory(category))
          )
      );
    }

    return this.byParentId.get(id) as Promise<ProductCategory[]>;
  }

  public async findProductCategoryByNameAndLineage(
    name: string,
    lineage: string[]
  ): Promise<ProductCategory | null> {
    const lookupKey = [...lineage, name].join(' > ');

    if (!this.byNameAndLineage.has(lookupKey)) {
      this.byNameAndLineage.set(
        lookupKey,
        this.collection
          .findProductCategoryByNameAndLineage(name, lineage)
          .then((category) => (!category ? category : this.getOrCacheProductCategory(category)))
      );
    }

    return this.byNameAndLineage.get(lookupKey) as Promise<ProductCategory | null>;
  }

  private getOrCacheProductCategory(category: ProductCategory) {
    if (this.productCategories[category.id]) {
      return this.productCategories[category.id];
    } else {
      this.productCategories[category.id] = category;
      return category;
    }
  }
}
